<template>
  <div>
    <b-modal ref="modalUnsavedChanges"
             :title="$t('Webportal.Dialog.UnsavedChanges.Title')"
             :ok-title="$t('Webportal.Dialog.UnsavedChanges.Ok')"
             :cancel-title="$t('Webportal.Dialog.UnsavedChanges.Cancel')">
      {{ $t('Webportal.Dialog.UnsavedChanges.Text') }}
    </b-modal>

    <div class="animated fadeIn">
      <div class="container">
          <b-nav tabs>
            <b-nav-item to="/administration/clientsettings"><font-awesome-icon :icon="['fas', 'building']" fixed-width /> {{ $t('Webportal.Administration.ClientSettings') }}</b-nav-item>
            <b-nav-item to="/administration/surveysettings"><font-awesome-icon :icon="['fas', 'file']" fixed-width /> {{ $t('Webportal.Administration.SurveySettings') }}</b-nav-item>
            <b-nav-item to="/administration/generalsettings"><font-awesome-icon :icon="['fas', 'cog']" fixed-width /> {{ $t('Webportal.Administration.GeneralSettings') }}</b-nav-item>
          </b-nav>
          <div class="tab-content" id="settings-pane">
            <div class="tab-pane fade show active" role="tabpanel">
              <keep-alive>
                <router-view @unsavedChanges="componentUnsavedChanges" />
              </keep-alive>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Administration",

  methods: {
    componentUnsavedChanges(isFormDirty, callback) {
      if (isFormDirty)
      {
        let dialog = this.$refs.modalUnsavedChanges;

        dialog.$off();
        dialog.$on('ok', _ => callback());
        dialog.$on('cancel', _ => callback(false));
        dialog.show();
      }
      else
        callback();
    }
  }
}
</script>